export default "__VITE_ASSET__D2ugBq8w__"